import { FunctionComponent, PropsWithChildren, useMemo } from 'react';

import { WithOptionsModel } from '../../../../../../../shared/components/with-options/models/with-options.model';
import { withOptions } from '../../../../../../../shared/components/with-options/with-options';
import { mapCategoryDtoToItemLabelModel } from '../../../../../../shared/utils/mapping/mapping.utils';
import { getCategories } from '../../../thunks/get-categories.thunk';
import { AppsFilterProps } from '../../../types/apps-filter-props.type';

const withCategoriesOptions = (
  Component: FunctionComponent<AppsFilterProps & WithOptionsModel>
): FunctionComponent<AppsFilterProps & WithOptionsModel> => {
  return (props: PropsWithChildren<AppsFilterProps & WithOptionsModel>) => {
    const WrappedComponent = useMemo(
      () =>
        withOptions(Component, {
          dispatchFn: getCategories,
          mapper: mapCategoryDtoToItemLabelModel,
          thunkArgs: undefined,
        }),
      []
    );

    return <WrappedComponent {...props} />;
  };
};

export default withCategoriesOptions;
